import React from 'react'

const Rank = () => {
	return (
		<div>
			<div className='white f3'>{'Ehmad, your current rank is ...'}</div>
			<div className='white f2'>{'#5'}</div>
		</div>
	)
}

export default Rank
